<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('News')}}</div>
        </div>
        <div class="news">
            <div class="list">
                <div class="item" v-for="(news, index) in list" :key="index" @click="$router.push({ path: '/about/' + news.id })">
                    <div class="item-img">
                        <img :src="news.img">
                    </div>
                    <div class="item-content">
                        <div class="item-title">{{ news.title }}</div>
                        <div class="item-desc">{{ news.time }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "news",
        data() {
            return {
                list: [],
                total: 0,
                pageNum: 1,
                pageLimit: 10,
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.getList();
        },
        methods: {
            getList() {
                Fetch('/index/news', {
                    page: this.pageNum,
                    limit: this.pageLimit
                }).then(res => {
                    this.list = res.data.list;
                    this.total = res.data.total;
                })
            },
        },
    }
</script>

<style scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .no_touch {
        pointer-events: none;
    }

    .wrap {
        padding: 20px;
    }
</style>